/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

export const dpPaymentForm = {
  dpPaymentForm: {
    redirect:
      'Pronto será redirigido a la página de terceros para el registro de la tarjeta',
    callback: 'Espera... Obtener detalles de pago...',
    cancelledOrFailed: 'Error o cancelación del registro de la tarjeta',
    error: {
      redirect: 'No se puede iniciar la operación. Por favor, inténtelo de nuevo',
      paymentFetch: 'No se pueden obtener los detalles de pago. Por favor, inténtelo de nuevo.',
      unknown:
        'Se ha producido un error desconocido al obtener el pago. Póngase en contacto con el servicio de asistencia',
    },
  },
};
